import { Right } from '@watersport/ui-react-icons'
import React from 'react'

import { AdaptiveImage } from 'features/common/components/AdaptiveImage'
import { cn } from 'features/common/helpers/cn'
import { File } from 'features/common/types'

type SelectItemType<T> = T & {
  label: string | React.ReactNode
  key: string
  file: File[] | undefined
}

export interface ActivityGridItemProps<T> {
  selected: boolean
  onClick: (item: SelectItemType<T>) => void
  item: SelectItemType<T>
  dataTestId?: string
}

const ActivityGridItem = <T,>({
  item,
  selected,
  onClick,
  dataTestId,
}: ActivityGridItemProps<T>): JSX.Element => (
  <div
    className="relative min-h-44 cursor-pointer"
    onClick={() => onClick(item)}
    data-testid={dataTestId}
  >
    {item.file && item.file.length > 0 && (
      <AdaptiveImage file={item.file[0]} className="w-full min-h-full object-cover rounded-xl" />
    )}
    {selected && (
      <div className="absolute right-1 top-2 p-2 bg-blue-800 rounded-full">
        <Right width={18} height={18} className="text-white" />
      </div>
    )}
    <p
      className={cn(
        'absolute bottom-2 left-1 right-1 px-3 py-2 bg-blue-100 text-black rounded-xl text-center text-sm leading-4 transition-colors',
        selected && 'bg-blue-800 text-white',
      )}
    >
      {item.label}
    </p>
  </div>
)

export default React.memo(ActivityGridItem)
